
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/post-launch/dashboard",
      function () {
        return require("private-next-pages/core-exchange/docs/post-launch/dashboard/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/post-launch/dashboard"])
      });
    }
  